import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, DatePicker, Redirect
} 
from '../../noser-hris-component';
import { DropdownButton, Dropdown} from 'react-bootstrap';
import BlacklistModal from './Modal/BlacklistModal';
class FinalInterviewCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userinfo        :   [],
            isloading       :   false,
            isshow          :   false,
            alerttype       :   "",
            message         :   "",
            color           :   "",
            fade            :   true,
            navigate    : false,
            clientDDL : [],
            assessmentDDL : [],
            assessmentId : "",
            commentsId:"",
            comments : "",
            //data : JSON.parse(sessionStorage.getItem("applicationforminterviews_" + this.state.userinfo.userId + this.state.userinfo.employeeId))
            openModal:false,
            remarksDDL:[]
        } 
        /* this.onChangeClientype=this.onChangeClientype.bind(this);  */
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.state.data = JSON.parse(sessionStorage.getItem("applicationforminterviews_" + this.state.userinfo.userId + this.state.userinfo.employeeId))
        
        this.state.applicationId   =   this.state.data.id
        this.state.profileId       =   this.state.data.profileId
        this.state.clientName      =   this.state.data.client
        this.state.clientId        =   this.state.data.clientId
        this.state.memberName      =   this.state.data.employeeName
        this.state.position        =   this.state.data.position
        this.state.positionId      =   this.state.data.positionId
       // this.state.address          = this.state.data.applicantAddresses[0].houseNumber + ", " + this.state.data.applicantAddresses[0].streetName+ ", " + this.state.data.applicantAddresses[0].barangay + ", " + this.state.data.applicantAddresses[0].city + ", " + this.state.data.applicantAddresses[0].province
       
    
    }

    componentDidMount(){
        const sleep = (milliseconds) => {return new Promise(resolve => setTimeout(resolve, milliseconds))}
        this.GetClient()
        
    }
    GetClient = async()=> {
        this.setState({isloading:true})
        const clientParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
        };
        await
        axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Client/GetClientList",  clientParams)
        .then(res => {
            const data = res.data;
            this.setState({
                clientDDL   :   data.clients
            });
        })
        .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetFinalAssessed()
    }

    GetFinalAssessed = async()=> {
        const departmentCodeParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Code"          :   "0011"
        };
        await
        axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetDataReferences",  departmentCodeParams)
        .then(res => {
            const data = res.data;
            this.setState({ assessmentDDL  : data.dataReferences });
        })
        .catch(error=>{
            this.setState({
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetRemarks()
    }
    GetRemarks = async()=> {
        const params = {
            "IpAddress"     : "0.0.0.0",
            "ClientId"      : this.state.userinfo.clientId,
            "UserId"        : this.state.userinfo.userId,
            "Name"          : ""
        };
        await
        axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetRecruitmentRemarks",  params)
        .then(res => {
            const data = res.data;
            this.setState({remarksDDL : data.recruitmentRemarks.filter(x=>x.typeId==="2")});
        })
        .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetApplicationFormDetails();
    }
    GetApplicationFormDetails = async()=> {
        //this.setState({isloading:true})

        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
            "ApplicationId" : this.state.applicationId,
        };
        console.log("applicationParams")
        console.log(params)
        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Recruitment/GetApplicationFormDetails",  params)
            .then(res => {
            const data = res.data;
            console.log("GetApplicationFormDetails")
            console.log(data)
            if(data.status==="1"){
                this.setState({
                    address :    data.applicantAddresses[0]["houseNumber"] + ", " +
                                        data.applicantAddresses[0]["streetName"] + ", " + 
                                        data.applicantAddresses[0]["barangay"] + ", " + 
                                        data.applicantAddresses[0]["city"] + ", " + 
                                        data.applicantAddresses[0]["province"] + ", " +
                                        data.applicantAddresses[0]["region"],
                                        isloading:false
                })
            }
            if(data.status=="0"){
               this.setState({
                   isloading   :   false,
                   alerttype   :   "Error!",
                   isshow      :   true,
                   color       :   "danger",
                   message     :   data.message,
                   fade        :   true
               });
            }
         })
         .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
    }
    handleModalShow = (e) =>{
        let obj = {
            "applicationFormId":this.state.applicationId,
            "positionId":this.state.positionId,
            "clientId" : this.state.clientId,
            "accountId" : "",
            "areaId":this.state.userinfo.areaId,
            "aquisitionId" : "",
            "statusId" : e,
        }
        this.setState({openModal:true})
        this.child.initialize(obj)
    }
    handleModalClose = (e) =>{
        this.setState({openModal:false})
    };
    
    handleChangedDDL = name => e =>{
        this.setState({alerttype:"",isshow:false,color:"",message:"",fade:true,isloading:false});
        if(e.length===0) {this.setState({[name]:""}); return}
        this.setState({[name]:e[0].id})
    }
    handleChangedComments = (e)=>{
        if(e.length == 0) {
            this.state.commentsId=""
            this.state.comments=""
            return
        }
        this.state.commentsId     =   e[0].id
        this.state.comments   =   e[0].name
    }

    handleClickStatus = (statusId) => {
        this.setState({isloading:true})

        const params = {
            "IpAddress"         :   "0.0.0.0",
            "ClientId"          :   this.state.clientId,
            "UserId"            :   this.state.userinfo.userId,
            "ApplicationFormId" :   this.state.applicationId,
            "AssessmentId"      :   this.state.assessmentId,
            "AssessedBy"        :   this.state.userinfo.userId,
            "Comments"          :   this.state.comments,
            "StatusId"          :   statusId,
         };

        console.log(params)
        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Recruitment/AddFinalInterview",  params)
            .then(res => {
                const data = res.data;
                if(data.status=="1"){
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Success!",
                    isshow      :   true,
                    color       :   "success",
                    message     :   data.message,
                    fade        :   true,
                    navigate    :   true,
                });
            
            }
            else {
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   data.message,
                    fade        :   true
                });
            }
        })

    };

    handleSubmit = async (StatusId) =>{
        this.setState({isloading:true,disableBtn:true})

        const param = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
            "ApplicationFormId":this.state.applicationId,
            "PositionId":this.state.positionId,
           /// "IsPooled":ispooled,

            /* "ClientId": "1",
            "IpAddress": "0.0.0.0",
            "UserId": "1",
            "ApplicationFormId": "",
            "PositionId": "" */
            "StatusId": StatusId, /* --> blacklisted - 12, process - 3  */

            "EducationalId":this.state.educationId,
            "IsFreshGrad":(this.state.freshGraduate)? "1" : "0",
            "WorkExperienceMonths":this.state.workExperienceMonths,
            "WorkExperienceYears":this.state.workExperienceYear,
            "WithWorkExperience":(this.state.withWorkExperience)? "1" : "0",
            "BodyBuiltId":this.state.bodyId,
            "HairId":this.state.hairId,
            "ComplexionId":this.state.complexionId,
            "PostureId": this.state.postureId,
            "PersonalityId":this.state.personalityId,
            "MentalId":this.state.mentalId,
            "WorkExperienceId":this.state.professionalId,
            "TechnicalExperienceId":this.state.technicalId,
            "SupportGroupId":this.state.supportGroupId,
            "AssessmentId":this.state.assessmentId,
            "Comments":this.state.comments,
            "RecommendationId":this.state.preFinalId,
            "AssessedBy":this.state.userinfo.userId,
            "StoreOperationId":this.state.storeId,
        };
        console.log("param")
        console.log(param)

        
        await axios
        .post(
            AppConfiguration.Setting().noserapiendpoint + "Pooling/SubmitPooling",  param
        )
        .then(res => {
            const data = res.data;
            this.setState({
                isloading   :   false,
                alerttype   :   res.data.status=="1" ? "Success!" : "!Error",
                isshow      :   true,
                color       :   res.data.status=="1" ? "success" : "danger",
                message     :   data.message,
                fade        :   true,
                name        :   ''
            });
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true,
                name        :   ''
            })
        })
    };
    handleConfirm=()=>{
        this.setState({isShow:true})
    };
    handleClose=()=>{
        this.setState({isShow:false, pooling : true})
    }


    render() {
        const { navigate } = this.state;
        if (navigate) {
            return <Redirect to="/applicationform" push={true} />;
        } 
        return(
            <div>
                <Banner />
                    <Container className="mt-5" fluid>
                        <Card>
                            <Card.Header>RECRUITMENT >> FINAL INTERVIEWS (CREATE)</Card.Header>
                            <Card.Body>
                                <Form>
                                    <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                        <div className={this.state.color}></div> 
                                        {this.state.message}
                                    </Alert>
                                    <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                        <div className={this.state.color}></div> 
                                        {this.state.message}
                                    </Alert>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridAddress1">
                                            <Form.Label style={{fontWeight : "bold"}}>CLIENT</Form.Label>
                                            <Typeahead 
                                                labelKey='name'
                                                id="basic-example"
                                                name="clientId"
                                                onChange={this.handleChangedDDL("clientId")}
                                                options={this.state.clientDDL}
                                                placeholder="Select Client" 
                                                disabled 
                                                defaultSelected={[this.state.clientName]}
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row className="mt-2">
                                        <Form.Group as={Col} controlId="formGridAddress1">
                                            <Form.Label style={{fontWeight : "bold"}}>EMPLOYEE</Form.Label>
                                                <Form.Control 
                                                    type="text"
                                                    name="memberName"
                                                    value={this.state.memberName}
                                                    //onChange={this.onChangeLastName} 
                                                    disabled 
                                                />
                                        </Form.Group>
                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridCity">
                                            <Form.Label style={{fontWeight : "bold",}}>CURRENT ADDRESS</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="address"
                                                value={this.state.address}
                                                //onChange={this.onChangeLastName} 
                                                disabled 
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row className="mt-2">
                                        <Form.Group as={Col} controlId="formGridAddress1">
                                            <Form.Label style={{fontWeight : "bold",}}>FINAL ASSESSMENT</Form.Label>
                                            <Typeahead 
                                                labelKey='name'
                                                id="basic-example"
                                                name="assessmentId"
                                                onChange={this.handleChangedDDL("assessmentId")}
                                                options={this.state.assessmentDDL}
                                                placeholder="Select FINAL ASSESSMENT" 
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridAddress1">
                                            <Form.Label style={{fontWeight : "bold",}}>ASSESSED BY</Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                autoComplete="off" 
                                                /* name="selectedClient" */
                                                value={this.state.userinfo.fullName}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row className="mt-2">
                                        <Form.Group as={Col} controlId="formGridAddress1">
                                            <Form.Label style={{fontWeight : "bold"}}>COMMENTS</Form.Label>
                                            <Typeahead 
                                                labelKey='name'
                                                id="basic-example"
                                                name='commentsId'
                                                onChange={this.handleChangedComments}
                                                options={this.state.remarksDDL}
                                                placeholder="SELECT COMMENTS " 
                                            />
                                            {/* <Form.Control
                                                as="textarea"
                                                rows="3"
                                                placeholder="Enter COMMENTS"
                                                onChange={this.handleChangeComments}
                                                autoComplete="off"
                                                value={this.state.comments}
                                                name={this.state.comments}
                                            /> */}
                                        </Form.Group>
                                    </Form.Row>
                                    <div isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isShow ? 'display-block' : 'display-none'}>
                                        <Card>
                                            <Card.Body>
                                            <h5 className='no-text-transform'>are you sure you want to blacklist this applicant?</h5>
                                            <ButtonToolbar >
                                                
                                                <Button variant="primary" className="noser-button-mr1 ml-auto" onClick = {() => this.handleSubmit('12')} disabled={this.state.disableBtn}>confirm</Button>
                                                
                                                <Button variant="danger" className="noser-button-mr15" onClick={this.handleClose}>Close</Button>
                                            </ButtonToolbar>
                                            </Card.Body>
                                        </Card>

                                    </div>
                                    <ButtonToolbar className="mt-3">
                                        {/* <Button className="ml-auto noser-button-mr1" variant="success" onClick = {() => this.handleClickStatus('1')}>Save</Button> */}
                                        <Button variant="warning" className="ml-auto noser-button-mr1" onClick = {() => this.handleModalShow('10')}>POOLING</Button>
                                        <Button variant="dark" className="noser-button-mr1" onClick = { () => this.handleModalShow('12')}>Blacklisted</Button>
                                        <Button className="noser-button-mr1"   variant="primary" onClick = {() => this.handleClickStatus('7')}>Submit</Button>                                    
                                        <NavLink to="/applicationform">
                                            <Button  className="noser-button noser-button-mr1" variant="danger">Back</Button>
                                        </NavLink>
                                    </ButtonToolbar>
                                   {/*  <ButtonToolbar className="mt-3">
                                        <Button variant="dark" className="ml-auto noser-button-mr1" onClick = {() => this.handleSubmit('12')}>POOLING</Button>
                                        <Button className=" noser-button-mr1" variant="success" onClick = {() => this.handleClickStatus('1')}>Save</Button>
                                        <Button className="noser-button-mr1"   variant="primary" onClick = {() => this.handleClickStatus('7')}>Submit</Button>                                    
                                        <NavLink to="/applicationform">
                                            <Button  className="noser-button noser-button-mr1" variant="danger">Back</Button>
                                        </NavLink>
                                    </ButtonToolbar> */}
                                </Form>
                            </Card.Body>
                        </Card>
                    </Container>
                <NoserLoading show={this.state.isloading} />
                <BlacklistModal 
                    show={this.state.openModal}
                    onHide={this.handleModalClose}
                    onRefModal={ref => (this.child = ref)}
                />
            </div> 
        )
    }

}

export  default FinalInterviewCreate
